import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Hero } from "@/components/sections/Hero";
import { BrandStory } from "@/components/sections/BrandStory";
import { Lessons } from "@/components/sections/Lessons";
import { Prices } from "@/components/sections/Prices";
import { Gallery } from "@/components/sections/Gallery";
import { Events } from "@/components/sections/Events";
import { Location } from "@/components/sections/Location";
import { Contact } from "@/components/sections/Contact";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 150);
    }
  }, [location]);

  return (
    <div className="bg-sand-100" data-testid="home-page">
      <Navbar />
      <Hero />
      <BrandStory />
      <Lessons />
      <Prices />
      <Gallery />
      <Events />
      <Location />
      <Contact />
      <Footer />
    </div>
  );
}
